module.exports = __webpack_public_path__ + "static/img/toubiqisize.fbe9210.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardProduct/images/toubiqisize.png
// module id = WclT
// module chunks = 1